/**
 * @module utilities/setupAxios
 * Setup axios on the window object and configure defaults
 */

import axios from 'axios'

declare global {
  // tslint:disable-next-line:interface-name
  interface Window {
    axios: any
  }
}

export default function setupAxios() {
  window.axios = axios
  axios.defaults.withCredentials = true
  axios.defaults.xsrfCookieName = 'csrftoken'
  axios.defaults.xsrfHeaderName = 'X-CSRFToken'
  axios.defaults.headers.common['Content-Type'] = 'application/json'
  axios.defaults.headers.common.charset = 'utf-8'
}
